import React from "react";

function ToursActivity() {
  const handleGetStarted = () => {};

  return (
    <div className="w-full flex-col-reverse lg:flex-row bg-[#EBEFF959] py-10 px-4 lg:px-20 rounded-lg flex items-center mb-10">
      <div className="flex flex-col flex-1">
        <span className="text-primary text-sm lg:text-base mb-4 font-bold">
          Tours
        </span>
        <span className="font-bold text-lg lg:text-xl mb-4">
          "Their communication across every step of the way makes them easy to
          work with."
        </span>
        <p className="text-sm">
          {`Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore Ut enim ad minim veniam, quis
          nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo con
          Duis aute irure dolor in reprehenderit`}
        </p>
        <button
          className="bg-primary text-white font-bold px-6 py-2 rounded-lg w-fit mt-6"
          onClick={handleGetStarted}
        >
          Get started
        </button>
      </div>

      <div className="flex flex-1 w-full lg:w-fit lg:justify-end mb-6 lg:mb-0">
        <div className="w-full lg:w-96 h-96 rounded-lg bg-[#D9D9D9]"></div>
      </div>
    </div>
  );
}

export default ToursActivity;
